import React from 'react';
import { PageLayoutContent, PageLayoutContentTitle, PageLayoutContentDescribe, FieldSet, FieldSetErrorMessage, Button, TextArea, FieldSetLabel, FieldSetInput, FieldSetInputSelect, Option, PageLayout, Toast, PageLayoutLoading, PageLayoutError, InternalLink, Icon, PageLayoutTitle, Input } from '@tolk-ai/ui-library-react';
import * as genericUtils from '@tolk-ai/generic-utils';
import * as customerApi from '@tolk-ai/connectors-config-customer-api';
import classNames from 'classnames';

const FormContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setFeedback: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setState: () => {},
  state: {
    formFields: {
      apiConnexion: {
        body: '',
        bodyTextAreaName: 'body',
        headers: {
          headersLines: []
        },
        method: 'GET',
        methodSelectName: 'method',
        url: '',
        urlInputName: 'url'
      },
      inputs: {
        inputsLines: []
      },
      outputs: {
        outputsLines: []
      },
      setup: {
        apiName: '',
        apiNameInputName: 'apiName'
      }
    },
    formState: {
      isDisabledTestButton: false,
      isLoading: false,
      isLoadingTestButton: false
    },
    testCustomerApiResponse: '',
    title: '',
    type: 'form'
  },
  testCustomerApi: new Promise( // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {})
});

const defaulApiConnexionLine = {
  identifier: '',
  property: '',
  propertyInputName: '',
  value: '',
  valueInputName: ''
};

const onAddHeadersLineButtonClick = (state, setState) => () => {
  const headersLineToAdd = Object.assign(Object.assign({}, defaulApiConnexionLine), {
    identifier: `headersLine#${genericUtils.generateRandomTagId()}`,
    propertyInputName: `property#${genericUtils.generateRandomTagId()}`,
    valueInputName: `value#${genericUtils.generateRandomTagId()}`
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
        headers: Object.assign(Object.assign({}, state.formFields.apiConnexion.headers), {
          headersLines: [...state.formFields.apiConnexion.headers.headersLines, headersLineToAdd]
        })
      })
    })
  }));
};

const onDeleteHeadersLineButtonClick = (state, setState) => event => {
  const filteredHeaders = state.formFields.apiConnexion.headers.headersLines.filter(headersLine => {
    return headersLine.identifier !== event.currentTarget.name;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
        headers: Object.assign(Object.assign({}, state.formFields.apiConnexion.headers), {
          headersLines: filteredHeaders
        })
      })
    })
  }));
};

const defaultInputsLine = {
  identifier: '',
  name: '',
  nameInputName: '',
  type: 'string',
  typeSelectName: '',
  value: '',
  valueInputName: ''
};

const onAddInputsLineButtonClick = (state, setState) => () => {
  const inputLineToAdd = Object.assign(Object.assign({}, defaultInputsLine), {
    identifier: `inputsLine#${genericUtils.generateRandomTagId()}`,
    nameInputName: `name#${genericUtils.generateRandomTagId()}`,
    typeSelectName: `type#${genericUtils.generateRandomTagId()}`,
    valueInputName: `value#${genericUtils.generateRandomTagId()}`
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      inputs: Object.assign(Object.assign({}, state.formFields.inputs), {
        inputsLines: [...state.formFields.inputs.inputsLines, inputLineToAdd]
      })
    })
  }));
};

const onDeleteInputsLineButtonClick = (state, setState) => event => {
  const filteredInputs = state.formFields.inputs.inputsLines.filter(inputsLine => {
    return inputsLine.identifier !== event.currentTarget.name;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      inputs: Object.assign(Object.assign({}, state.formFields.inputs), {
        inputsLines: filteredInputs
      })
    })
  }));
};

const onCustomerApiNameInputChange = (state, setState) => event => {
  if (event.target.name === state.formFields.setup.apiNameInputName) {
    setState(Object.assign(Object.assign({}, state), {
      formFields: Object.assign(Object.assign({}, state.formFields), {
        setup: Object.assign(Object.assign({}, state.formFields.setup), {
          apiName: event.target.value
        })
      })
    }));
  }
};

const onCustomerApiInputsInputChange = (state, setState) => event => {
  const currentInputsLine = state.formFields.inputs.inputsLines.find(inputsLine => event.target.name === inputsLine.nameInputName || event.target.name === inputsLine.valueInputName);

  if (typeof currentInputsLine !== 'undefined') {
    const updatedInputsLines = state.formFields.inputs.inputsLines.map(inputsLine => {
      if (inputsLine.nameInputName === event.target.name) {
        return Object.assign(Object.assign({}, inputsLine), {
          name: event.target.value
        });
      }

      if (inputsLine.valueInputName === event.target.name) {
        return Object.assign(Object.assign({}, inputsLine), {
          value: event.target.value
        });
      }

      return inputsLine;
    });
    setState(Object.assign(Object.assign({}, state), {
      formFields: Object.assign(Object.assign({}, state.formFields), {
        inputs: Object.assign(Object.assign({}, state.formFields.inputs), {
          inputsLines: updatedInputsLines
        })
      })
    }));
  }
};

const onCustomerApiInputsTypeSelectChange = (state, setState) => selectName => value => {
  const currentInputsLine = state.formFields.inputs.inputsLines.find(inputsLine => selectName === inputsLine.typeSelectName);

  if (typeof currentInputsLine === 'undefined') {
    return;
  }

  const updatedInputsLines = state.formFields.inputs.inputsLines.map(inputsLine => {
    if (inputsLine === currentInputsLine) {
      return Object.assign(Object.assign({}, inputsLine), {
        type: value
      });
    }

    return inputsLine;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      inputs: Object.assign(Object.assign({}, state.formFields.inputs), {
        inputsLines: updatedInputsLines
      })
    })
  }));
};

const onCustomerApiOutputsInputChange = (state, setState) => event => {
  const currentOutputsLine = state.formFields.outputs.outputsLines.find(outputsLine => event.target.name === outputsLine.nameInputName || event.target.name === outputsLine.valueInputName);

  if (typeof currentOutputsLine === 'undefined') {
    return;
  }

  const updatedOutputsLines = state.formFields.outputs.outputsLines.map(outputsLine => {
    if (outputsLine.nameInputName === event.target.name) {
      return Object.assign(Object.assign({}, outputsLine), {
        name: event.target.value
      });
    }

    if (outputsLine.valueInputName === event.target.name) {
      return Object.assign(Object.assign({}, outputsLine), {
        value: event.target.value
      });
    }

    return outputsLine;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      outputs: Object.assign(Object.assign({}, state.formFields.outputs), {
        outputsLines: updatedOutputsLines
      })
    })
  }));
};

const onCustomerApiOutputsTypeSelectChange = (state, setState) => selectName => value => {
  const currentOutputsLine = state.formFields.outputs.outputsLines.find(outputsLine => selectName === outputsLine.typeSelectName);

  if (typeof currentOutputsLine === 'undefined') {
    return;
  }

  const updatedOutputsLines = state.formFields.outputs.outputsLines.map(outputsLine => {
    if (outputsLine === currentOutputsLine) {
      return Object.assign(Object.assign({}, outputsLine), {
        type: value
      });
    }

    return outputsLine;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      outputs: Object.assign(Object.assign({}, state.formFields.outputs), {
        outputsLines: updatedOutputsLines
      })
    })
  }));
};

const onCustomerApiApiConnexionInputChange = (state, setState) => event => {
  if (event.target.name === state.formFields.apiConnexion.urlInputName) {
    setState(Object.assign(Object.assign({}, state), {
      formFields: Object.assign(Object.assign({}, state.formFields), {
        apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
          url: event.target.value
        })
      })
    }));
    return;
  }

  if (event.target.name === state.formFields.apiConnexion.bodyTextAreaName) {
    setState(Object.assign(Object.assign({}, state), {
      formFields: Object.assign(Object.assign({}, state.formFields), {
        apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
          body: event.target.value
        })
      })
    }));
    return;
  }

  const currentHeadersLine = state.formFields.apiConnexion.headers.headersLines.find(headerLines => event.target.name === headerLines.propertyInputName || event.target.name === headerLines.valueInputName);

  if (typeof currentHeadersLine === 'undefined') {
    return;
  }

  const updatedHeadersLines = state.formFields.apiConnexion.headers.headersLines.map(headerLines => {
    if (headerLines.propertyInputName === event.target.name) {
      return Object.assign(Object.assign({}, headerLines), {
        property: event.target.value
      });
    }

    if (headerLines.valueInputName === event.target.name) {
      return Object.assign(Object.assign({}, headerLines), {
        value: event.target.value
      });
    }

    return headerLines;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
        headers: Object.assign(Object.assign({}, state.formFields.apiConnexion.headers), {
          headersLines: updatedHeadersLines
        })
      })
    })
  }));
};

const onCustomerApiApiConnexionMethodSelectChange = (state, setState) => selectName => value => {
  if (selectName === state.formFields.apiConnexion.methodSelectName) {
    setState(Object.assign(Object.assign({}, state), {
      formFields: Object.assign(Object.assign({}, state.formFields), {
        apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
          body: '',
          method: value
        })
      })
    }));
  }
};

const onCustomerApiApiConnexionTextAreaBlur = (state, setState) => event => {
  if (!genericUtils.isJson(event.target.value)) {
    return;
  }

  const NUMBER = {
    JSON_STRINGIFY_SPACE: 4
  };
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      apiConnexion: Object.assign(Object.assign({}, state.formFields.apiConnexion), {
        body: JSON.stringify(JSON.parse(event.target.value), null, NUMBER.JSON_STRINGIFY_SPACE)
      })
    })
  }));
};

const defaultSubmittedFormFields = formFields => {
  return Object.assign(Object.assign({}, formFields), {
    apiConnexion: Object.assign(Object.assign({}, formFields.apiConnexion), {
      apiUrlErrorMessage: undefined,
      headers: {
        headersLines: formFields.apiConnexion.headers.headersLines.map(headersLine => {
          return Object.assign(Object.assign({}, headersLine), {
            hasPropertyError: undefined,
            hasValueError: undefined
          });
        })
      },
      method: formFields.apiConnexion.method,
      url: formFields.apiConnexion.url
    }),
    inputs: Object.assign(Object.assign({}, formFields.inputs), {
      inputsLines: formFields.inputs.inputsLines.map(inputsLine => {
        return Object.assign(Object.assign({}, inputsLine), {
          hasNameError: undefined,
          hasValueError: undefined
        });
      })
    }),
    outputs: Object.assign(Object.assign({}, formFields.outputs), {
      outputsLines: formFields.outputs.outputsLines.map(outputsLine => {
        return Object.assign(Object.assign({}, outputsLine), {
          hasOutputsNameError: undefined,
          hasOutputsValueError: undefined
        });
      })
    }),
    setup: Object.assign(Object.assign({}, formFields.setup), {
      apiName: formFields.setup.apiName,
      apiNameErrorMessage: undefined
    })
  });
};

const apiConnexionBodyWithErrorChecking = apiConnexionFields => {
  if (apiConnexionFields.method === 'GET') {
    return undefined;
  }

  return genericUtils.isJson(apiConnexionFields.body) ? undefined : 'Body is not a valid JSON';
};

const inputsFieldsWithErrorChecking = inputsFields => {
  const inputsLinesWithError = inputsFields.inputsLines.map(inputsLine => {
    if (genericUtils.isEmpty(inputsLine.name) && genericUtils.isEmpty(inputsLine.value)) {
      return inputsLine;
    }

    return Object.assign(Object.assign({}, inputsLine), {
      hasNameError: genericUtils.isEmpty(inputsLine.name) ? true : undefined,
      hasValueError: genericUtils.isEmpty(inputsLine.value) ? true : undefined
    });
  });
  const displayFieldSetErrorMessage = inputsLinesWithError.some(inputsLineError => {
    return inputsLineError.hasNameError === true || inputsLineError.hasValueError === true;
  });
  return {
    errorMessage: displayFieldSetErrorMessage ? 'Inputs values cannot be empty' : undefined,
    inputsLines: inputsLinesWithError
  };
};

const ouputsFieldsWithErrorChecking = ouputsFields => {
  const ouputsLinesWithError = ouputsFields.outputsLines.map(outputsLine => {
    if (genericUtils.isEmpty(outputsLine.name) && genericUtils.isEmpty(outputsLine.value)) {
      return outputsLine;
    }

    return Object.assign(Object.assign({}, outputsLine), {
      hasNameError: genericUtils.isEmpty(outputsLine.name) ? true : undefined,
      hasValueError: genericUtils.isEmpty(outputsLine.value) ? true : undefined
    });
  });
  const displayFieldSetErrorMessage = ouputsLinesWithError.some(outputsLineError => {
    return outputsLineError.hasNameError === true || outputsLineError.hasValueError === true;
  });
  return {
    errorMessage: displayFieldSetErrorMessage ? 'Outputs values cannot be empty' : undefined,
    outputsLines: ouputsLinesWithError
  };
};

const apiConnexionFieldsWithErrorChecking = headersFields => {
  const headersLinesWithError = headersFields.headersLines.map(headersLine => {
    if (genericUtils.isEmpty(headersLine.property) && genericUtils.isEmpty(headersLine.value)) {
      return headersLine;
    }

    return Object.assign(Object.assign({}, headersLine), {
      hasPropertyError: genericUtils.isEmpty(headersLine.property) ? true : undefined,
      hasValueError: genericUtils.isEmpty(headersLine.value) ? true : undefined
    });
  });
  const displayFieldSetErrorMessage = headersLinesWithError.some(outputsLineError => {
    return outputsLineError.hasPropertyError === true || outputsLineError.hasValueError === true;
  });
  return {
    errorMessage: displayFieldSetErrorMessage ? 'Api headers values cannot be empty' : undefined,
    headersLines: headersLinesWithError
  };
};

const checkIfFormContainErrors = fields => {
  if (typeof fields === 'undefined') {
    return false;
  }

  if (typeof fields === 'string') {
    return true;
  }

  return typeof fields.errorMessage === 'string';
};

const convertHeadersToCustomerApiInfoHeaders = headersLines => {
  if (headersLines.every(headersLine => genericUtils.isEmpty(headersLine.property) && genericUtils.isEmpty(headersLine.value))) {
    return [];
  }

  const filteredHeadersLines = headersLines.filter(headersLine => {
    return !genericUtils.isEmpty(headersLine.property) && !genericUtils.isEmpty(headersLine.value);
  });
  return filteredHeadersLines.map(apiHeader => {
    return {
      name: apiHeader.property,
      value: apiHeader.value
    };
  });
};

const convertInputsToCustomerApiInfoInputs = inputsLines => {
  if (inputsLines.every(inputsLine => genericUtils.isEmpty(inputsLine.name) && genericUtils.isEmpty(inputsLine.value))) {
    return [];
  }

  const filteredInputsLines = inputsLines.filter(inputsLine => {
    return !genericUtils.isEmpty(inputsLine.name) && !genericUtils.isEmpty(inputsLine.value);
  });
  return filteredInputsLines.map(inputsLine => {
    return {
      name: inputsLine.name,
      type: inputsLine.type,
      value: inputsLine.value
    };
  });
};

const convertOutputsToCustomerApiInfoOutputs = outputsLines => {
  if (outputsLines.every(outputsLine => genericUtils.isEmpty(outputsLine.name) && genericUtils.isEmpty(outputsLine.value) && typeof outputsLine.type === 'undefined')) {
    return [];
  }

  const filteredOutputsLine = outputsLines.filter(outputsLine => {
    return !genericUtils.isEmpty(outputsLine.name) && !genericUtils.isEmpty(outputsLine.value) && typeof outputsLine.type !== 'undefined';
  });
  return filteredOutputsLine.map(outputsLine => {
    return {
      name: outputsLine.name,
      type: outputsLine.type,
      value: outputsLine.value
    };
  });
};

const convertApiConnexionToCustomerApiDataBase = (apiConnexionFields, customerApiDataBase) => {
  if (apiConnexionFields.method === 'POST') {
    return Object.assign(Object.assign({}, customerApiDataBase), {
      body: apiConnexionFields.body,
      method: apiConnexionFields.method
    });
  }

  return Object.assign(Object.assign({}, customerApiDataBase), {
    method: apiConnexionFields.method
  });
};

const onCreateApiSubmit = async (botId, submittedState, setFeedback, setState, createOneCustomerApiInfo) => {
  try {
    const customerApiDataBase = {
      headers: convertHeadersToCustomerApiInfoHeaders(submittedState.formFields.apiConnexion.headers.headersLines),
      inputs: convertInputsToCustomerApiInfoInputs(submittedState.formFields.inputs.inputsLines),
      name: submittedState.formFields.setup.apiName,
      outputs: [],
      url: submittedState.formFields.apiConnexion.url
    };
    const customerApiData = convertApiConnexionToCustomerApiDataBase(submittedState.formFields.apiConnexion, customerApiDataBase);
    const result = await createOneCustomerApiInfo(botId, customerApiData);

    if (genericUtils.isDomainError(result, customerApi.appPorts.CreateOneCustomerApiInfoErrors)) {
      switch (result) {
        case customerApi.appPorts.CreateOneCustomerApiInfoErrors.invalidUrlFormat:
          setState(Object.assign(Object.assign({}, submittedState), {
            formFields: Object.assign(Object.assign({}, submittedState.formFields), {
              apiConnexion: Object.assign(Object.assign({}, submittedState.formFields.apiConnexion), {
                apiUrlErrorMessage: 'URL format is invalid'
              })
            }),
            formState: Object.assign(Object.assign({}, submittedState.formState), {
              isLoading: false
            })
          }));
          return;

        default:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: Object.assign(Object.assign({}, submittedState.formState), {
              isLoading: false
            })
          }));
          break;
      }

      return;
    }

    setState(Object.assign(Object.assign({}, submittedState), {
      apiId: result,
      formState: Object.assign(Object.assign({}, submittedState.formState), {
        isDisabledTestButton: false,
        isLoading: false
      }),
      title: submittedState.formFields.setup.apiName,
      type: 'form'
    }));
    setFeedback({
      message: 'Custom API was successfully saved',
      type: 'success'
    });
  } catch (_a) {
    setFeedback({
      message: 'An error occured, please retry',
      type: 'danger'
    });
    setState(Object.assign(Object.assign({}, submittedState), {
      formState: Object.assign(Object.assign({}, submittedState.formState), {
        isLoading: false
      })
    }));
  }
};

const onUpdateApiSubmit = async (apiId, botId, submittedState, setFeedback, setState, updateOneCustomerApiInfo) => {
  try {
    const customerApiDataBase = {
      headers: convertHeadersToCustomerApiInfoHeaders(submittedState.formFields.apiConnexion.headers.headersLines),
      inputs: convertInputsToCustomerApiInfoInputs(submittedState.formFields.inputs.inputsLines),
      name: submittedState.formFields.setup.apiName,
      outputs: convertOutputsToCustomerApiInfoOutputs(submittedState.formFields.outputs.outputsLines),
      url: submittedState.formFields.apiConnexion.url
    };
    const customerApiData = convertApiConnexionToCustomerApiDataBase(submittedState.formFields.apiConnexion, customerApiDataBase);
    const result = await updateOneCustomerApiInfo(botId, apiId, customerApiData);

    if (genericUtils.isDomainError(result, customerApi.appPorts.CreateOneCustomerApiInfoErrors)) {
      switch (result) {
        case customerApi.appPorts.UpdateOneCustomerApiInfoErrors.inexistingCustomerApi:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: Object.assign(Object.assign({}, submittedState.formState), {
              isLoading: false
            })
          }));
          return;

        case customerApi.appPorts.UpdateOneCustomerApiInfoErrors.invalidUrlFormat:
          setState(Object.assign(Object.assign({}, submittedState), {
            formFields: Object.assign(Object.assign({}, submittedState.formFields), {
              apiConnexion: Object.assign(Object.assign({}, submittedState.formFields.apiConnexion), {
                apiUrlErrorMessage: 'URL format is invalid'
              })
            }),
            formState: Object.assign(Object.assign({}, submittedState.formState), {
              isLoading: false
            })
          }));
          return;

        default:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: Object.assign(Object.assign({}, submittedState.formState), {
              isLoading: false
            })
          }));
          break;
      }

      return;
    }

    setFeedback({
      message: 'Custom API was successfully updated',
      type: 'success'
    });
    setState(Object.assign(Object.assign({}, submittedState), {
      apiId,
      formState: Object.assign(Object.assign({}, submittedState.formState), {
        isLoading: false
      }),
      title: submittedState.formFields.setup.apiName,
      type: 'form'
    }));
  } catch (_a) {
    setFeedback({
      message: 'An error occured, please retry',
      type: 'danger'
    });
    setState(Object.assign(Object.assign({}, submittedState), {
      formState: Object.assign(Object.assign({}, submittedState.formState), {
        isLoading: false
      })
    }));
  }
};

const onSubmit = (apiId, botId, state, setFeedback, setState, createOneCustomerApiInfo, updateOneCustomerApiInfo) => async event => {
  event.preventDefault();
  const submitFormField = defaultSubmittedFormFields(state.formFields);
  const submittedState = Object.assign(Object.assign({}, state), {
    apiId: state.apiId,
    formFields: submitFormField,
    formState: Object.assign(Object.assign({}, state.formState), {
      isLoading: true
    }),
    title: typeof state.apiId === 'undefined' ? state.title : state.formFields.setup.apiName,
    type: 'form'
  });
  setState(submittedState);
  const customerApiNameErrorMessage = genericUtils.isEmpty(submitFormField.setup.apiName) ? 'API name input cannot be empty' : undefined;
  const customerApiApiConnexionUrlErrorMessage = genericUtils.isEmpty(submitFormField.apiConnexion.url) ? 'URL input cannot be empty' : undefined;
  const customerApiApiConnexionBodyErrorMessage = apiConnexionBodyWithErrorChecking(submitFormField.apiConnexion);
  const inputsFieldsChecking = inputsFieldsWithErrorChecking(submitFormField.inputs);
  const outputsFieldsChecking = ouputsFieldsWithErrorChecking(submitFormField.outputs);
  const headersFieldsChecking = apiConnexionFieldsWithErrorChecking(submitFormField.apiConnexion.headers);

  if (checkIfFormContainErrors(customerApiNameErrorMessage) || checkIfFormContainErrors(customerApiApiConnexionUrlErrorMessage) || checkIfFormContainErrors(inputsFieldsChecking) || checkIfFormContainErrors(headersFieldsChecking) || checkIfFormContainErrors(outputsFieldsChecking) || checkIfFormContainErrors(customerApiApiConnexionBodyErrorMessage)) {
    setState(Object.assign(Object.assign({}, submittedState), {
      formFields: Object.assign(Object.assign({}, submitFormField), {
        apiConnexion: Object.assign(Object.assign({}, submitFormField.apiConnexion), {
          apiUrlErrorMessage: customerApiApiConnexionUrlErrorMessage,
          bodyErrorMessage: customerApiApiConnexionBodyErrorMessage,
          headers: headersFieldsChecking
        }),
        inputs: inputsFieldsChecking,
        outputs: outputsFieldsChecking,
        setup: Object.assign(Object.assign({}, submitFormField.setup), {
          apiNameErrorMessage: customerApiNameErrorMessage
        })
      }),
      formState: Object.assign(Object.assign({}, state.formState), {
        isLoading: false
      })
    }));
    setFeedback({
      message: 'Some fields seem incorrect, please check and retry',
      type: 'danger'
    });
    return;
  }

  if (typeof apiId === 'undefined') {
    await onCreateApiSubmit(botId, submittedState, setFeedback, setState, createOneCustomerApiInfo);
    return;
  }

  await onUpdateApiSubmit(apiId, botId, submittedState, setFeedback, setState, updateOneCustomerApiInfo);
};

const defaultFormField = {
  apiConnexion: {
    body: '',
    bodyTextAreaName: 'body',
    headers: {
      headersLines: [{
        identifier: `headersLine#${genericUtils.generateRandomTagId()}`,
        property: '',
        propertyInputName: `property#${genericUtils.generateRandomTagId()}`,
        value: '',
        valueInputName: `value#${genericUtils.generateRandomTagId()}`
      }]
    },
    method: 'GET',
    methodSelectName: 'method',
    url: '',
    urlInputName: 'url'
  },
  inputs: {
    inputsLines: [{
      identifier: `inputsLine#${genericUtils.generateRandomTagId()}`,
      name: '',
      nameInputName: `name#${genericUtils.generateRandomTagId()}`,
      type: 'string',
      typeSelectName: `type#${genericUtils.generateRandomTagId()}`,
      value: '',
      valueInputName: `value#${genericUtils.generateRandomTagId()}`
    }]
  },
  outputs: {
    outputsLines: []
  },
  setup: {
    apiName: '',
    apiNameInputName: 'apiName'
  }
};

const convertCustomerApiInfoHeadersToCustomerApiHeadersLines = customerApiInfoHeaders => {
  if (genericUtils.isEmpty(customerApiInfoHeaders)) {
    return defaultFormField.apiConnexion.headers.headersLines;
  }

  return customerApiInfoHeaders.map(customerApiInfoHeader => {
    return {
      identifier: `headersLine#${genericUtils.generateRandomTagId()}`,
      property: customerApiInfoHeader.name,
      propertyInputName: `property#${genericUtils.generateRandomTagId()}`,
      value: customerApiInfoHeader.value,
      valueInputName: `value#${genericUtils.generateRandomTagId()}`
    };
  });
};

const convertCustomerApiInfoInputsToCustomerApiInputsLines = customerApiInfoInputs => {
  if (genericUtils.isEmpty(customerApiInfoInputs)) {
    return defaultFormField.inputs.inputsLines;
  }

  return customerApiInfoInputs.map(customerApiInfoInput => {
    return {
      identifier: `inputsLine#${genericUtils.generateRandomTagId()}`,
      name: customerApiInfoInput.name,
      nameInputName: `name#${genericUtils.generateRandomTagId()}`,
      type: customerApiInfoInput.type,
      typeSelectName: `type#${genericUtils.generateRandomTagId()}`,
      value: customerApiInfoInput.value,
      valueInputName: `value#${genericUtils.generateRandomTagId()}`
    };
  });
};

const convertCustomerApiInfoOutputsToCustomerApiOutputsLines = customerApiInfoOutputs => {
  return customerApiInfoOutputs.map(customerApiInfoOutput => {
    return {
      identifier: `outputLine#${genericUtils.generateRandomTagId()}`,
      name: customerApiInfoOutput.name,
      nameInputName: `outputNameLine#${genericUtils.generateRandomTagId()}`,
      type: customerApiInfoOutput.type,
      typeSelectName: `outputTypeLine#${genericUtils.generateRandomTagId()}`,
      value: customerApiInfoOutput.value,
      valueInputName: `outputValueLine#${genericUtils.generateRandomTagId()}`
    };
  });
};

const convertToCustomerApiDataToApiConnexion = customerApiData => {
  const headersFormFields = Object.assign(Object.assign({}, defaultFormField.apiConnexion.headers), {
    headersLines: convertCustomerApiInfoHeadersToCustomerApiHeadersLines(customerApiData.headers)
  });
  const {
    url,
    method
  } = customerApiData;

  if (method === 'POST') {
    const {
      body
    } = customerApiData;
    return Object.assign(Object.assign({}, defaultFormField.apiConnexion), {
      body,
      headers: headersFormFields,
      method,
      url
    });
  }

  return Object.assign(Object.assign({}, defaultFormField.apiConnexion), {
    headers: headersFormFields,
    method,
    url
  });
};

const init = async (botId, history, setState, getOneCustomerApiInfo) => {
  try {
    setState({
      type: 'loading'
    });

    if (typeof history.location.state === 'undefined') {
      setState({
        formFields: defaultFormField,
        formState: {
          isDisabledTestButton: true,
          isLoading: false,
          isLoadingTestButton: false
        },
        testCustomerApiResponse: '',
        title: 'Create an API',
        type: 'form'
      });
      return;
    }

    const historyLocationState = history.location.state;

    if (typeof historyLocationState.customerApiId === 'undefined') {
      setState({
        message: 'An error occured, please retry',
        type: 'error'
      });
      return;
    }

    const result = await getOneCustomerApiInfo(botId, historyLocationState.customerApiId);

    if (genericUtils.isDomainError(result, customerApi.appPorts.GetOneCustomerApiInfoErrors)) {
      switch (result) {
        case customerApi.appPorts.GetOneCustomerApiInfoErrors.inexistingCustomerApiInfo:
          setState({
            message: 'An error occured, please retry',
            type: 'error'
          });
          break;

        default:
          setState({
            message: 'An error occured, please retry',
            type: 'error'
          });
          break;
      }

      return;
    }

    setState({
      apiId: result.id,
      formFields: Object.assign(Object.assign({}, defaultFormField), {
        apiConnexion: convertToCustomerApiDataToApiConnexion(result.details),
        inputs: Object.assign(Object.assign({}, defaultFormField.inputs), {
          inputsLines: convertCustomerApiInfoInputsToCustomerApiInputsLines(result.details.inputs)
        }),
        outputs: Object.assign(Object.assign({}, defaultFormField.outputs), {
          outputsLines: convertCustomerApiInfoOutputsToCustomerApiOutputsLines(result.details.outputs)
        }),
        setup: Object.assign(Object.assign({}, defaultFormField.setup), {
          apiName: result.details.name
        })
      }),
      formState: {
        isDisabledTestButton: false,
        isLoading: false,
        isLoadingTestButton: false
      },
      testCustomerApiResponse: '',
      title: result.details.name,
      type: 'form'
    });
  } catch (_a) {
    setState({
      message: 'An error occured, please retry',
      type: 'error'
    });
  }
};

const onInit = async (botId, history, setState, getOneCustomerApiInfo) => {
  await init(botId, history, setState, getOneCustomerApiInfo);
};

const onRetryButtonClick = (botId, history, setState, getOneCustomerApiInfo) => async () => {
  await init(botId, history, setState, getOneCustomerApiInfo);
};

const defaultOutputLine = {
  identifier: '',
  name: '',
  nameInputName: '',
  type: 'string',
  typeSelectName: '',
  value: '',
  valueInputName: ''
};

const onAddOutputsLineButtonClick = (state, setState) => () => {
  const outputLineToAdd = Object.assign(Object.assign({}, defaultOutputLine), {
    identifier: `outputLine#${genericUtils.generateRandomTagId()}`,
    nameInputName: `outputNameLine#${genericUtils.generateRandomTagId()}`,
    typeSelectName: `outputTypeLine#${genericUtils.generateRandomTagId()}`,
    valueInputName: `outputValueLine#${genericUtils.generateRandomTagId()}`
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      outputs: Object.assign(Object.assign({}, state.formFields.outputs), {
        outputsLines: [...state.formFields.outputs.outputsLines, outputLineToAdd]
      })
    })
  }));
};

const onDeleteOutputsLineButtonClick = (state, setState) => event => {
  const filteredOutputs = state.formFields.outputs.outputsLines.filter(outputsLine => {
    return outputsLine.identifier !== event.currentTarget.name;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      outputs: Object.assign(Object.assign({}, state.formFields.outputs), {
        outputsLines: filteredOutputs
      })
    })
  }));
};

const onTestButtonClick = (botId, customerApiId, testCustomerApi, setFeedback, state, setState) => async () => {
  try {
    if (typeof customerApiId === 'undefined') {
      setFeedback({
        message: 'An error occured, please retry',
        type: 'danger'
      });
      return;
    }

    setState(Object.assign(Object.assign({}, state), {
      formState: {
        isDisabledTestButton: true,
        isLoading: false,
        isLoadingTestButton: true
      },
      testCustomerApiResponse: '...'
    }));
    const result = await testCustomerApi(botId, customerApiId);

    if (genericUtils.isDomainError(result, customerApi.appPorts.TestCustomerApiErrors)) {
      switch (result) {
        case customerApi.appPorts.TestCustomerApiErrors.inexistingCustomerApi:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, state), {
            formState: {
              isDisabledTestButton: false,
              isLoading: false,
              isLoadingTestButton: false
            },
            testCustomerApiResponse: {
              response: 'Unable to test the API, please retry',
              type: 'error'
            }
          }));
          return;

        default:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, state), {
            formState: {
              isDisabledTestButton: false,
              isLoading: false,
              isLoadingTestButton: false
            },
            testCustomerApiResponse: {
              response: 'Unable to test the API, please retry',
              type: 'error'
            }
          }));
          return;
      }
    }

    const outputLineToAdd = Object.assign(Object.assign({}, defaultOutputLine), {
      identifier: `outputLine#${genericUtils.generateRandomTagId()}`,
      nameInputName: `outputNameLine#${genericUtils.generateRandomTagId()}`,
      typeSelectName: `outputTypeLine#${genericUtils.generateRandomTagId()}`,
      valueInputName: `outputValueLine#${genericUtils.generateRandomTagId()}`
    });
    const updatedOutputs = Object.assign(Object.assign({}, state.formFields.outputs), {
      outputsLines: genericUtils.isEmpty(state.formFields.outputs.outputsLines) ? [outputLineToAdd] : state.formFields.outputs.outputsLines
    });

    if (state.formFields.outputs.outputsLines.length === genericUtils.NUMBER.ZERO) {
      setState(Object.assign(Object.assign({}, state), {
        formFields: Object.assign(Object.assign({}, state.formFields), {
          outputs: updatedOutputs
        })
      }));
    }

    const responseSuccess = result.response;
    const responseError = result.response;

    if (typeof responseError.error === 'undefined') {
      setState(Object.assign(Object.assign({}, state), {
        formFields: Object.assign(Object.assign({}, state.formFields), {
          outputs: updatedOutputs
        }),
        formState: {
          isDisabledTestButton: false,
          isLoading: false,
          isLoadingTestButton: false
        },
        testCustomerApiResponse: {
          response: responseSuccess.data,
          type: 'success'
        }
      }));
      return;
    }

    if (typeof responseSuccess.data === 'undefined') {
      setState(Object.assign(Object.assign({}, state), {
        formFields: Object.assign(Object.assign({}, state.formFields), {
          outputs: updatedOutputs
        }),
        formState: {
          isDisabledTestButton: false,
          isLoading: false,
          isLoadingTestButton: false
        },
        testCustomerApiResponse: {
          response: responseError.error,
          type: 'error'
        }
      }));
      return;
    }
  } catch (_a) {
    setFeedback({
      message: 'An error occured, please retry',
      type: 'danger'
    });
    setState(Object.assign(Object.assign({}, state), {
      formState: {
        isDisabledTestButton: false,
        isLoading: false,
        isLoadingTestButton: false
      },
      testCustomerApiResponse: {
        response: 'Unable to test the API, please retry',
        type: 'error'
      }
    }));
  }
};

const onToastHide = setFeedback => () => {
  setFeedback(null);
};

var styles$9 = {"api-connexion":"index-module_api-connexion__x8hZ2","api-connexion__add-button":"index-module_api-connexion__add-button__g06QN","api-connexion__settings":"index-module_api-connexion__settings__PlThF","api-connexion__headers":"index-module_api-connexion__headers__xCGO2","api-connexion__label-text-area-component":"index-module_api-connexion__label-text-area-component__lHftY","api-connexion__text-area-component":"index-module_api-connexion__text-area-component__BmgzB"};

const ApiConnexion = () => {
  const formContextDatas = React.useContext(FormContext);
  const onAddHeadersLineButtonClick$1 = onAddHeadersLineButtonClick(formContextDatas.state, formContextDatas.setState);
  const onUrlInputChange = onCustomerApiApiConnexionInputChange(formContextDatas.state, formContextDatas.setState);
  const onMethodSelectChange = onCustomerApiApiConnexionMethodSelectChange(formContextDatas.state, formContextDatas.setState);
  const onTextAreaChange = onCustomerApiApiConnexionInputChange(formContextDatas.state, formContextDatas.setState);
  const onCustomerApiApiConnexionTextAreaBlur$1 = onCustomerApiApiConnexionTextAreaBlur(formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, {
    className: styles$9['api-connexion']
  }, /*#__PURE__*/React.createElement(PageLayoutContentTitle, null, "Api connexion"), /*#__PURE__*/React.createElement(PageLayoutContentDescribe, null, "Setup your API Connexion"), /*#__PURE__*/React.createElement(UrlSettings, {
    apiConnexionFields: formContextDatas.state.formFields.apiConnexion,
    onMethodSelectChange: onMethodSelectChange,
    onUrlInputChange: onUrlInputChange
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$9['api-connexion__settings']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$9['api-connexion__headers']
  }, /*#__PURE__*/React.createElement(FieldSet, {
    hasError: typeof formContextDatas.state.formFields.apiConnexion.headers.errorMessage === 'string',
    legend: "Api headers group"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, formContextDatas.state.formFields.apiConnexion.headers.headersLines.map((headersLine, index) => {
    return /*#__PURE__*/React.createElement(HeadersLine, {
      headers: headersLine,
      key: headersLine.identifier,
      onDeleteApiHeadersLineButtonClick: onDeleteHeadersLineButtonClick(formContextDatas.state, formContextDatas.setState),
      onPropertyInputChange: onCustomerApiApiConnexionInputChange(formContextDatas.state, formContextDatas.setState),
      onValueInputChange: onCustomerApiApiConnexionInputChange(formContextDatas.state, formContextDatas.setState),
      position: index
    });
  })), /*#__PURE__*/React.createElement(FieldSetErrorMessage, null, formContextDatas.state.formFields.apiConnexion.headers.errorMessage)), /*#__PURE__*/React.createElement(Button, {
    className: styles$9['api-connexion__add-button'],
    icon: {
      name: 'PlusIcon',
      position: 'left-icon'
    },
    isOutlined: true,
    onClick: onAddHeadersLineButtonClick$1,
    type: "button"
  }, "Add")), /*#__PURE__*/React.createElement(TextArea, {
    isDisabled: formContextDatas.state.formFields.apiConnexion.method === 'GET',
    isResizable: formContextDatas.state.formFields.apiConnexion.method === 'POST',
    label: "Body",
    labelClassName: styles$9['api-connexion__label-text-area-component'],
    name: formContextDatas.state.formFields.apiConnexion.bodyTextAreaName,
    onTextAreaBlur: onCustomerApiApiConnexionTextAreaBlur$1,
    onTextAreaChange: onTextAreaChange,
    placeholder: "{}",
    state: typeof formContextDatas.state.formFields.apiConnexion.bodyErrorMessage === 'undefined' ? undefined : {
      message: formContextDatas.state.formFields.apiConnexion.bodyErrorMessage,
      type: 'error'
    },
    textAreaClassName: styles$9['api-connexion__text-area-component'],
    value: formContextDatas.state.formFields.apiConnexion.body
  })));
};

var styles$8 = {"headers__api-headers":"index-module_headers__api-headers__331eO","headers__property":"index-module_headers__property__Ig2rr","headers__value":"index-module_headers__value__TBkSB","headers__delete-button--hidden":"index-module_headers__delete-button--hidden__b8aG4"};

const HeadersLine = ({
  headers,
  position,
  onDeleteApiHeadersLineButtonClick,
  onPropertyInputChange,
  onValueInputChange
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$8['headers__api-headers'],
    key: headers.identifier
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$8.headers__property
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: headers.propertyInputName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "API Headers", ' ', /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, headers.propertyInputName)), position !== genericUtils.NUMBER.ZERO && `${headers.propertyInputName}`)), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: headers.propertyInputName,
    name: headers.propertyInputName,
    onChange: onPropertyInputChange,
    placeholder: "Property",
    state: headers.hasPropertyError === true ? {
      type: 'error'
    } : undefined,
    value: headers.property
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$8.headers__value
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: headers.valueInputName,
    screenReaderOnly: true
  }, headers.valueInputName), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: headers.valueInputName,
    name: headers.valueInputName,
    onChange: onValueInputChange,
    placeholder: "Value",
    state: headers.hasValueError === true ? {
      type: 'error'
    } : undefined,
    value: headers.value
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles$8['headers__delete-button--hidden']]: position === genericUtils.ARRAY.FIRST_INDEX
    })
  }, ' ', /*#__PURE__*/React.createElement(Button, {
    icon: {
      border: 'none',
      name: 'TrashIcon',
      screenReaderDescribe: `Delete button with identifier ${headers.identifier}`
    },
    isOutlined: true,
    name: headers.identifier,
    onClick: onDeleteApiHeadersLineButtonClick,
    type: "button"
  })));
};

var styles$7 = {"api-url-settings__api-url":"index-module_api-url-settings__api-url__AJNjk","api-url-settings__verb-select":"index-module_api-url-settings__verb-select__EKg6Z","api-url-settings__url":"index-module_api-url-settings__url__wUWiv"};

const UrlSettings = ({
  apiConnexionFields,
  onMethodSelectChange,
  onUrlInputChange
}) => {
  return /*#__PURE__*/React.createElement(FieldSet, {
    hasError: typeof apiConnexionFields.apiUrlErrorMessage === 'string',
    legend: "URL and method settings"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7['api-url-settings__api-url']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$7['api-url-settings__verb-select']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: apiConnexionFields.methodSelectName
  }, "API URL*"), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    inputIdentifier: apiConnexionFields.methodSelectName,
    onChange: onMethodSelectChange(apiConnexionFields.methodSelectName),
    value: apiConnexionFields.method
  }, /*#__PURE__*/React.createElement(Option, {
    value: "GET"
  }, "GET"), /*#__PURE__*/React.createElement(Option, {
    value: "POST"
  }, "POST"))), /*#__PURE__*/React.createElement("div", {
    className: styles$7['api-url-settings__url']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: "url",
    screenReaderOnly: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "API URL INPUT ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "URL"))), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: apiConnexionFields.urlInputName,
    name: apiConnexionFields.urlInputName,
    onChange: onUrlInputChange,
    placeholder: "URL",
    state: typeof apiConnexionFields.apiUrlErrorMessage === 'string' ? {
      type: 'error'
    } : undefined,
    value: apiConnexionFields.url
  }))), /*#__PURE__*/React.createElement(FieldSetErrorMessage, null, apiConnexionFields.apiUrlErrorMessage));
};

var styles$6 = {"customer-api-form__form":"index-module_customer-api-form__form__XlffL","customer-api-form__outputs":"index-module_customer-api-form__outputs__ueVTd","customer-api-form__save-button":"index-module_customer-api-form__save-button__bqNNi"};

const CustomerApiForm = ({
  botId,
  state,
  createOneCustomerApiInfo,
  setFeedback,
  setState,
  updateOneCustomerApiInfo
}) => {
  const onSubmit$1 = onSubmit(state.apiId, botId, state, setFeedback, setState, createOneCustomerApiInfo, updateOneCustomerApiInfo);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: state.title
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    className: styles$6['customer-api-form__form'],
    method: "post",
    onSubmit: onSubmit$1
  }, /*#__PURE__*/React.createElement(Setup, null), /*#__PURE__*/React.createElement(Inputs, null), /*#__PURE__*/React.createElement(ApiConnexion, null), /*#__PURE__*/React.createElement(Button, {
    className: styles$6['customer-api-form__save-button'],
    isBlock: true,
    isDisabled: state.formState.isLoading,
    isLoading: state.formState.isLoading,
    type: "submit"
  }, "Save")), /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    className: classNames(styles$6['customer-api-form__outputs'], {
      [styles$6['customer-api-form__outputs--show-outputs']]: state.formFields.outputs.outputsLines.length !== genericUtils.NUMBER.ZERO
    })
  }, /*#__PURE__*/React.createElement(OutputsViewer, {
    botId: botId,
    customerApiId: state.apiId
  }))));
};

const CustomerApiFormViewer = ({
  botId,
  createOneCustomerApiInfo,
  getOneCustomerApiInfo,
  testCustomerApi,
  updateOneCustomerApiInfo,
  history
}) => {
  const [state, setState] = React.useState({
    type: 'loading'
  });
  const [feedback, setFeedback] = React.useState(null);
  const value = React.useMemo(() => {
    return {
      setFeedback,
      setState,
      state: state,
      testCustomerApi
    };
  }, [state, testCustomerApi]);
  React.useEffect(() => {
    void onInit(botId, history, setState, getOneCustomerApiInfo);
    return () => {
      setFeedback(null);
    };
  }, [botId, getOneCustomerApiInfo, history]);
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(React.Fragment, null, feedback !== null && /*#__PURE__*/React.createElement(Toast, {
    autoHide: {
      isActive: true,
      onHide: onToastHide(setFeedback)
    },
    position: {
      location: 'bottom-left'
    },
    type: feedback.type
  }, feedback.message), state.type === 'loading' && /*#__PURE__*/React.createElement(PageLayoutLoading, null), state.type === 'error' && /*#__PURE__*/React.createElement(PageLayoutError, {
    buttonText: "Retry",
    message: state.message,
    onButtonClick: onRetryButtonClick(botId, history, setState, getOneCustomerApiInfo)
  }), state.type === 'form' && /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(CustomerApiForm, {
    botId: botId,
    createOneCustomerApiInfo: createOneCustomerApiInfo,
    setFeedback: setFeedback,
    setState: setState,
    state: state,
    updateOneCustomerApiInfo: updateOneCustomerApiInfo
  }))));
};

var styles$5 = {"customer-apis-form-title":"index-module_customer-apis-form-title__IBhTb","customer-apis-form-title__internal-link":"index-module_customer-apis-form-title__internal-link__yjoyQ","customer-apis-form-title__layout-title":"index-module_customer-apis-form-title__layout-title__8yZ7H"};

const Header = ({
  title
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5['customer-apis-form-title']
  }, /*#__PURE__*/React.createElement(InternalLink, {
    className: styles$5['customer-apis-form-title__internal-link'],
    path: "/customer-apis"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "ArrowCircleLeftIcon"
  })), /*#__PURE__*/React.createElement(PageLayoutTitle, {
    className: styles$5['customer-apis-form-title__layout-title']
  }, title));
};

var styles$4 = {"inputs__add-button":"index-module_inputs__add-button__Cs8aI"};

/* eslint-disable max-lines-per-function */

const Inputs = () => {
  const formContextDatas = React.useContext(FormContext);
  const onAddInputsButtonClick = onAddInputsLineButtonClick(formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, null, /*#__PURE__*/React.createElement(PageLayoutContentTitle, null, "Inputs"), /*#__PURE__*/React.createElement(PageLayoutContentDescribe, null, "Set your API Inputs requirements"), /*#__PURE__*/React.createElement(FieldSet, {
    hasError: typeof formContextDatas.state.formFields.inputs.errorMessage !== 'undefined',
    legend: "Inputs group"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, formContextDatas.state.formFields.inputs.inputsLines.map((inputsLine, index) => {
    return /*#__PURE__*/React.createElement(InputsLine, {
      inputLine: inputsLine,
      key: inputsLine.identifier,
      onDeleteInputLineButtonClick: onDeleteInputsLineButtonClick(formContextDatas.state, formContextDatas.setState),
      onNameInputChange: onCustomerApiInputsInputChange(formContextDatas.state, formContextDatas.setState),
      onTestInputChange: onCustomerApiInputsInputChange(formContextDatas.state, formContextDatas.setState),
      onTypeSelectChange: onCustomerApiInputsTypeSelectChange(formContextDatas.state, formContextDatas.setState),
      position: index
    });
  })), /*#__PURE__*/React.createElement(FieldSetErrorMessage, null, formContextDatas.state.formFields.inputs.errorMessage)), /*#__PURE__*/React.createElement(Button, {
    className: styles$4['inputs__add-button'],
    icon: {
      name: 'PlusIcon',
      position: 'left-icon'
    },
    isOutlined: true,
    onClick: onAddInputsButtonClick,
    type: "button"
  }, "Add"));
};

var styles$3 = {"input-line__inputs":"index-module_input-line__inputs__2Ke99","input-line__name":"index-module_input-line__name__EqlMd","input-line__type":"index-module_input-line__type__sd-ZV","input-line__value":"index-module_input-line__value__IJSMV","input-line__delete-button--hidden":"index-module_input-line__delete-button--hidden__LKvcF"};

const InputsLine = ({
  inputLine,
  position,
  onNameInputChange,
  onTypeSelectChange,
  onTestInputChange,
  onDeleteInputLineButtonClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$3['input-line__inputs']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3['input-line__name']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: inputLine.nameInputName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "name ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, inputLine.nameInputName)), position !== genericUtils.NUMBER.ZERO && `${inputLine.nameInputName}`)), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: inputLine.nameInputName,
    name: inputLine.nameInputName,
    onChange: onNameInputChange,
    placeholder: "Input",
    state: inputLine.hasNameError === true ? {
      type: 'error'
    } : undefined,
    value: inputLine.name
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$3['input-line__type']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: inputLine.typeSelectName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "Type ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, inputLine.typeSelectName)), position !== genericUtils.NUMBER.ZERO && `${inputLine.typeSelectName}`)), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    inputIdentifier: inputLine.typeSelectName,
    onChange: onTypeSelectChange(inputLine.typeSelectName),
    value: inputLine.type
  }, /*#__PURE__*/React.createElement(Option, {
    value: "string"
  }, "String"), /*#__PURE__*/React.createElement(Option, {
    value: "number"
  }, "Number"))), /*#__PURE__*/React.createElement("div", {
    className: styles$3['input-line__value']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: inputLine.valueInputName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "Test value", ' ', /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, inputLine.valueInputName)), position !== genericUtils.NUMBER.ZERO && `${inputLine.valueInputName}`)), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: inputLine.valueInputName,
    name: inputLine.valueInputName,
    onChange: onTestInputChange,
    placeholder: "XXXXXX",
    state: inputLine.hasValueError === true ? {
      type: 'error'
    } : undefined,
    value: inputLine.value
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles$3['input-line__delete-button--hidden']]: position === genericUtils.ARRAY.FIRST_INDEX
    })
  }, /*#__PURE__*/React.createElement(Button, {
    icon: {
      border: 'none',
      name: 'TrashIcon',
      screenReaderDescribe: `Delete button with identifier ${inputLine.identifier}`
    },
    isOutlined: true,
    name: inputLine.identifier,
    onClick: onDeleteInputLineButtonClick,
    type: "button"
  })));
};

var styles$2 = {"outputs":"index-module_outputs__RoU4-","outputs__content":"index-module_outputs__content__NhMPs","outputs__return":"index-module_outputs__return__nRjZN","outputs__text-area-component":"index-module_outputs__text-area-component__jJNLS","outputs__line-output":"index-module_outputs__line-output__474fU","outputs__add-button":"index-module_outputs__add-button__pG5yx"};

const Outputs = ({
  botId
}) => {
  const NUMBER = {
    JSON_STRINGIFY_SPACE: 4
  };
  const formContextDatas = React.useContext(FormContext);
  const onAddOutputsLineButtonClick$1 = onAddOutputsLineButtonClick(formContextDatas.state, formContextDatas.setState);
  const onTestButtonClick$1 = onTestButtonClick(botId, formContextDatas.state.apiId, formContextDatas.testCustomerApi, formContextDatas.setFeedback, formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, {
    className: styles$2.outputs
  }, /*#__PURE__*/React.createElement(PageLayoutContentTitle, null, "Test your API"), /*#__PURE__*/React.createElement(PageLayoutContentDescribe, null, /*#__PURE__*/React.createElement(React.Fragment, null, "Check the return and setup outputs and its values with an existing API or after saving a new one. ", /*#__PURE__*/React.createElement("br", null), " You can set many outputs after the returned API response. Don't forget to save to update your API.")), /*#__PURE__*/React.createElement("div", {
    className: styles$2.outputs__content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.outputs__return
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextArea, {
    isResizable: formContextDatas.state.formFields.outputs.outputsLines.length !== genericUtils.NUMBER.ZERO,
    label: "return",
    name: "outputs",
    placeholder: "Returned output from custom API",
    readOnly: true,
    state: typeof formContextDatas.state.testCustomerApiResponse === 'string' ? undefined : typeof formContextDatas.state.testCustomerApiResponse.response === 'string' ? {
      type: 'error'
    } : formContextDatas.state.testCustomerApiResponse.type === 'success' ? {
      type: 'success'
    } : {
      message: 'Response from API return an error',
      type: 'error'
    },
    textAreaClassName: styles$2['outputs__text-area-component'],
    value: typeof formContextDatas.state.testCustomerApiResponse === 'string' ? formContextDatas.state.testCustomerApiResponse : typeof formContextDatas.state.testCustomerApiResponse.response === 'string' ? formContextDatas.state.testCustomerApiResponse.response : JSON.stringify(formContextDatas.state.testCustomerApiResponse.response, null, NUMBER.JSON_STRINGIFY_SPACE)
  })), /*#__PURE__*/React.createElement(Button, {
    isBlock: true,
    isDisabled: formContextDatas.state.formState.isDisabledTestButton,
    isLoading: formContextDatas.state.formState.isLoadingTestButton,
    onClick: onTestButtonClick$1
  }, "Test again")), /*#__PURE__*/React.createElement("div", {
    className: styles$2.outputs__fields
  }, /*#__PURE__*/React.createElement(FieldSet, {
    hasError: typeof formContextDatas.state.formFields.outputs.errorMessage !== 'undefined',
    legend: "Inputs group"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, formContextDatas.state.formFields.outputs.outputsLines.map((outputLine, index) => {
    return /*#__PURE__*/React.createElement(OutputsLine, {
      key: outputLine.identifier,
      onDeleteOutputLineButtonClick: onDeleteOutputsLineButtonClick(formContextDatas.state, formContextDatas.setState),
      onOutputNameChange: onCustomerApiOutputsInputChange(formContextDatas.state, formContextDatas.setState),
      onOutputTypeSelectChange: onCustomerApiOutputsTypeSelectChange(formContextDatas.state, formContextDatas.setState),
      onOutputValueChange: onCustomerApiOutputsInputChange(formContextDatas.state, formContextDatas.setState),
      outputsLine: outputLine,
      position: index
    });
  })), /*#__PURE__*/React.createElement(FieldSetErrorMessage, null, formContextDatas.state.formFields.outputs.errorMessage)), formContextDatas.state.formFields.outputs.outputsLines.length !== genericUtils.ARRAY.EMPTY_LENGTH && /*#__PURE__*/React.createElement(Button, {
    className: styles$2['outputs__add-button'],
    icon: {
      name: 'PlusIcon',
      position: 'left-icon'
    },
    isOutlined: true,
    onClick: onAddOutputsLineButtonClick$1
  }, "Add ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "output line")))));
};

var styles$1 = {"outputs-line":"index-module_outputs-line__6uNAY","outputs-line__output-name":"index-module_outputs-line__output-name__Q34li","outputs-line__output-value":"index-module_outputs-line__output-value__ztBs6","outputs-line__output-type":"index-module_outputs-line__output-type__5l3Sx","outputs-line__delete-button--hidden":"index-module_outputs-line__delete-button--hidden__DBNpK","outputs-line__fields":"index-module_outputs-line__fields__ze7sb"};

const OutputsLine = ({
  outputsLine,
  position,
  onOutputNameChange,
  onOutputTypeSelectChange,
  onOutputValueChange,
  onDeleteOutputLineButtonClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$1['outputs-line'],
    key: outputsLine.identifier
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['outputs-line__output-value']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: outputsLine.valueInputName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "value", ' ', /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, outputsLine.valueInputName)), position !== genericUtils.NUMBER.ZERO && `${outputsLine.valueInputName}`)), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: outputsLine.valueInputName,
    name: outputsLine.valueInputName,
    onChange: onOutputValueChange,
    placeholder: "Set an output path",
    state: outputsLine.hasValueError === true ? {
      type: 'error'
    } : undefined,
    value: outputsLine.value
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1['outputs-line__output-name']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: outputsLine.nameInputName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "name", ' ', /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, outputsLine.nameInputName)), position !== genericUtils.NUMBER.ZERO && `${outputsLine.nameInputName}`)), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: outputsLine.nameInputName,
    name: outputsLine.nameInputName,
    onChange: onOutputNameChange,
    placeholder: "Name this output",
    state: outputsLine.hasNameError === true ? {
      type: 'error'
    } : undefined,
    value: outputsLine.name
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1['outputs-line__output-type']
  }, /*#__PURE__*/React.createElement(FieldSetLabel, {
    inputIdentifier: outputsLine.typeSelectName,
    screenReaderOnly: position !== genericUtils.NUMBER.ZERO
  }, /*#__PURE__*/React.createElement(React.Fragment, null, position === genericUtils.NUMBER.ZERO && /*#__PURE__*/React.createElement(React.Fragment, null, "Type", ' ', /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, outputsLine.typeSelectName)), position !== genericUtils.NUMBER.ZERO && `${outputsLine.typeSelectName}`)), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    inputIdentifier: outputsLine.typeSelectName,
    onChange: onOutputTypeSelectChange(outputsLine.typeSelectName),
    value: outputsLine.type
  }, /*#__PURE__*/React.createElement(Option, {
    value: "boolean"
  }, "Boolean"), /*#__PURE__*/React.createElement(Option, {
    value: "number"
  }, "Number"), /*#__PURE__*/React.createElement(Option, {
    value: "string"
  }, "String"))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles$1['outputs-line__delete-button--hidden']]: position === genericUtils.ARRAY.FIRST_INDEX
    })
  }, /*#__PURE__*/React.createElement(Button, {
    icon: {
      border: 'none',
      name: 'TrashIcon',
      screenReaderDescribe: `Delete button with identifier ${outputsLine.identifier}`
    },
    isOutlined: true,
    name: outputsLine.identifier,
    onClick: onDeleteOutputLineButtonClick,
    type: "button"
  })));
};

/* eslint-disable react-hooks/exhaustive-deps */

const OutputsViewer = ({
  botId,
  customerApiId
}) => {
  const formContextDatas = React.useContext(FormContext);
  const [feedback, setFeedback] = React.useState(null);
  React.useEffect(() => {
    formContextDatas.setState(Object.assign(Object.assign({}, formContextDatas.state), {
      formState: Object.assign(Object.assign({}, formContextDatas.state.formState), {
        isDisabledTestButton: typeof customerApiId === 'undefined'
      })
    }));
  }, [customerApiId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, feedback !== null && /*#__PURE__*/React.createElement(Toast, {
    autoHide: {
      isActive: true,
      onHide: onToastHide(setFeedback)
    },
    position: {
      location: 'bottom-left'
    },
    type: "danger"
  }, feedback.message), /*#__PURE__*/React.createElement(Outputs, {
    botId: botId
  }));
};

var styles = {"customer-api-form-setup__input-name":"index-module_customer-api-form-setup__input-name__dtGUO","customer-api-form-setup":"index-module_customer-api-form-setup__LDDzX"};

const Setup = () => {
  const formContextDatas = React.useContext(FormContext);
  const onChange = onCustomerApiNameInputChange(formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, null, /*#__PURE__*/React.createElement(PageLayoutContentTitle, {
    className: styles['customer-api-form-setup']
  }, "Setup"), /*#__PURE__*/React.createElement("div", {
    className: styles['customer-api-form-setup__input-name']
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Api name*",
    name: formContextDatas.state.formFields.setup.apiNameInputName,
    onChange: onChange,
    placeholder: "Api name",
    state: typeof formContextDatas.state.formFields.setup.apiNameErrorMessage === 'undefined' ? undefined : {
      message: formContextDatas.state.formFields.setup.apiNameErrorMessage,
      type: 'error'
    },
    value: formContextDatas.state.formFields.setup.apiName
  })));
};

const component = (createOneCustomerApiInfo, updateOneCustomerApiInfo, getOneCustomerApiInfo, testCustomerApi, history) => ({
  botId
}) => {
  return /*#__PURE__*/React.createElement(CustomerApiFormViewer, {
    botId: botId,
    createOneCustomerApiInfo: createOneCustomerApiInfo,
    getOneCustomerApiInfo: getOneCustomerApiInfo,
    history: history,
    testCustomerApi: testCustomerApi,
    updateOneCustomerApiInfo: updateOneCustomerApiInfo
  });
};

export { component };
